import { render, staticRenderFns } from "./FileUploadWidget.vue?vue&type=template&id=0f3543b2&"
import script from "./FileUploadWidget.vue?vue&type=script&lang=ts&"
export * from "./FileUploadWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports